import React from 'react';
import injectSheet from 'react-jss';
import cx from 'classnames';
var styles = {
  bar: {
    width: 25,
    height: 3,
    margin: '4px 0',
    transition: '0.4s'
  },
  bar1: {
    extend: 'bar',
    backgroundColor: function backgroundColor(props) {
      return props.color;
    } // @HACK: jss-react with jss-extend does not work if extended class is dynamically computed by component props

  },
  bar2: {
    extend: 'bar',
    backgroundColor: function backgroundColor(props) {
      return props.color;
    }
  },
  bar3: {
    extend: 'bar',
    backgroundColor: function backgroundColor(props) {
      return props.color;
    }
  },
  container: {
    display: 'inline-block',
    cursor: 'pointer'
  },
  expanded: {
    '& $bar1': {
      transform: 'rotate(-45deg) translate(-6px, 6px)'
    },
    '& $bar2': {
      opacity: 0
    },
    '& $bar3': {
      transform: 'rotate(45deg) translate(-4px, -4px)'
    }
  }
};
export function Hamburger(_ref) {
  var className = _ref.className,
      classes = _ref.classes,
      isExpanded = _ref.isExpanded,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(classes.container, className, {
      [classes.expanded]: isExpanded
    }),
    onClick: onClick,
    role: "button",
    tabIndex: "0",
    "aria-pressed": "false"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.bar1
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.bar2
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.bar3
  }));
}
// Since we need to expose the default props to JSS
Hamburger.defaultProps = {
  color: '#000'
};
export default injectSheet(styles)(Hamburger);